export enum ComponentDefaultTestId {
  // Don't remove next line
  // plop_marker:default-data-testid-declarations
  LIST_TITLE = "list-title",
  EMPTY_STATE = "empty-state",
  TRANSITION_VIEW = "transition-view",
  TEXT_AREA = "text-area",
  EDITABLE_TEXT = "editable-text",
  TIPSEEN_MEDIA = "tipseen-media",
  INDICATOR = "indicator",
  BADGE = "badge",
  TITLE = "title",
  TEXT = "text",
  COMBOBOX = "combobox",
  COMBOBOX_CATEGORY = "combobox-category",
  COMBOBOX_OPTION = "combobox-option",
  COLOR_PICKER = "color-picker",
  CHECKBOX = "checkbox",
  CHECKBOX_LABEL = "checkbox-label",
  CHECKBOX_CHECKBOX = "checkbox-checkbox",
  DROPDOWN = "dropdown",
  DROPDOWN_OPTION_CONTENT = "dropdown-option-content",
  BUTTON = "button",
  BUTTON_GROUP = "button-group",
  CLICKABLE = "clickable",
  VIRTUALIZED_LIST = "virtualized-list",
  VIRTUALIZED_GRID = "virtualized-grid",
  TEXT_FIELD = "text-field",
  TEXT_FIELD_SECONDARY_BUTTON = "text-field-secondary-button",
  SEARCH = "search",
  CLEAN_SEARCH_BUTTON = "clean-search-button",
  COLOR_PICKER_ITEM = "color-picker-item",
  ICON_BUTTON = "icon-button",
  INFO = "info",
  SVG_ICON = "svg-icon",
  CHIP = "chip",
  RADIO_BUTTON = "radio-button",
  RADIO_BUTTON_LABEL = "radio-button-label",
  RADIO_BUTTON_CONTROL = "radio-button-control",
  TAB = "tab",
  TAB_PANEL = "tab-panel",
  TAB_PANELS = "tab-panels",
  TAB_LIST = "tab-list",
  TABS_CONTEXT = "tabs-context",
  ALERT_BANNER = "alert-banner",
  ALERT_BANNER_BUTTON = "alert-banner-button",
  ALERT_BANNER_LINK = "alert-banner-link",
  ALERT_BANNER_TEXT = "alert-banner-text",
  ATTENTION_BOX = "attention-box",
  BOX = "box",
  AVATAR = "avatar",
  AVATAR_BADGE = "avatar-badge",
  AVATAR_CONTENT = "avatar-content",
  BREADCRUMB_ITEM = "breadcrumb-item",
  BREADCRUMBS_BAR = "breadcrumbs-bar",
  BREADCRUMB_MENU = "breadcrumb-menu",
  BREADCRUMB_MENU_ITEM = "breadcrumb-menu-item",
  PROGRESS_BAR = "progress-bar",
  BAR = "bar",
  BAR_PRIMARY = "bar-primary",
  BAR_SECONDARY = "bar-secondary",
  COLOR_PICKER_ITEM_COMPONENT = "color-picker-item-component",
  COUNTER = "counter",
  MENU = "menu",
  OPTION = "option",
  EXPAND_COLLAPSE = "expand-collapse",
  EDITABLE_INPUT = "editable-input",
  EDITABLE_HEADING = "editable-heading",
  HEADING = "heading",
  LABEL = "label",
  LINK = "link",
  MENU_DIVIDER = "menu-divider",
  MENU_ITEM = "menu-item",
  MENU_ITEM_BUTTON = "menu-item-button",
  MENU_TITLE = "menu-title",
  MENU_TITLE_CAPTION = "menu-title-caption",
  MENU_GRID_ITEM = "menu-grid-item",
  MENU_BUTTON = "menu-button",
  STEP_INDICATOR = "step-indicator",
  STEPS = "steps",
  STEPS_FORWARD_COMMAND = "steps-forward-command",
  STEPS_BACKWARD_COMMAND = "steps-backward-command",
  MULTI_STEP_INDICATOR = "multi-step-indicator",
  SKELETON = "skeleton",
  SPLIT_BUTTON = "split-button",
  SPLIT_BUTTON_PRIMARY_BUTTON = "split-button-primary-button",
  SPLIT_BUTTON_SECONDARY_BUTTON = "split-button-secondary-button",
  TEXT_WITH_HIGHLIGHT = "text-with-highlight",
  TOAST = "toast",
  TOAST_CONTENT = "toast-content",
  TOAST_LINK = "toast-link",
  TOAST_BUTTON = "toast-button",
  TOAST_CLOSE_BUTTON = "toast-close-button",
  TOGGLE = "toggle",
  TIPSEEN = "tipseen",
  TIPSEEN_CONTENT = "tipseen-content",
  TIPSEEN_CONTENT_SUBMIT = "tipseen-content-submit",
  TIPSEEN_CONTENT_DISMISS = "tipseen-content-dismiss",
  TIPSEEN_TITLE = "tipseen-title",
  DIVIDER = "divider",
  DATEPICKER = "date-picker",
  DATEPICKER_HEADER = "date-picker-header",
  DATEPICKER_YEAR_SELECTION = "date-picker-year-selection",
  LOADER = "loader",
  ICON = "icon",
  RESPONSIVE_LIST = "responsive-list",
  LIST = "list",
  MODAL = "modal",
  MODAL_OVERLAY = "modal-overlay",
  MODAL_HEADER = "modal-header",
  MODAL_CLOSE_BUTTON = "modal-close-button",
  MODAL_CONTENT = "modal-content",
  MODAL_FOOTER = "modal-footer",
  MODAL_MEDIA = "modal-media",
  MODAL_BASIC_LAYOUT = "modal-basic-layout",
  MODAL_SIDE_BY_SIDE_LAYOUT = "modal-side-by-side-layout",
  MODAL_MEDIA_LAYOUT = "modal-media-layout",
  FORMATTED_NUMBER = "formatted-number",
  HIDDEN_TEXT = "hidden-text",
  DIALOG_CONTENT_CONTAINER = "dialog-content-container",
  FLEX = "flex",
  TOOLTIP = "tooltip",
  DIALOG = "dialog",
  TABLE = "table",
  TABLE_CONTAINER = "table-container",
  TABLE_BODY = "table-body",
  TABLE_VIRTUALIZED_BODY = "table-virtualized-body",
  TABLE_CELL = "table-cell",
  TABLE_HEADER = "table-header",
  TABLE_HEADER_CELL = "table-header-cell",
  TABLE_ROW = "table-row",
  TABLE_ROW_MENU = "table-row-menu"
}

export enum NavigationCommand {
  RIGHT_ARROW = "{arrowright}",
  LEFT_ARROW = "{arrowleft}",
  UP_ARROW = "{arrowup}",
  DOWN_ARROW = "{arrowdown}",
  TAB = "#TAB#",
  ENTER = "{enter}",
  PAGE_UP = "{pageup}",
  PAGE_DOWN = "{pagedown}"
}

export enum ComponentVibeId {
  ACCORDION = "Accordion",
  LIST_TITLE = "ListTitle",
  ALERT_BANNER = "AlertBanner",
  ATTENTION_BOX = "AttentionBox",
  AVATAR = "Avatar",
  AVATAR_GROUP = "AvatarGroup",
  BADGE = "Badge",
  BOX = "Box",
  BREADCRUMBS_BAR = "BreadcrumbsBar",
  BUTTON = "Button",
  BUTTON_GROUP = "ButtonGroup",
  CHECKBOX = "Checkbox",
  CHIPS = "Chips",
  COLOR_PICKER = "ColorPicker",
  COMBOBOX = "Combobox",
  COUNTER = "Counter",
  DATE_PICKER = "DatePicker",
  DIALOG = "Dialog",
  DIVIDER = "Divider",
  DROPDOWN = "Dropdown",
  EDITABLE_HEADING = "EditableHeading",
  EDITABLE_TEXT = "EditableText",
  EMPTY_STATE = "EmptyState",
  EXPAND_COLLAPSE = "ExpandCollapse",
  FLEX = "Flex",
  HEADING = "Heading",
  ICON = "Icon",
  ICON_BUTTON = "IconButton",
  INFO = "Info",
  LABEL = "Label",
  PROGRESS_BAR = "ProgressBar",
  LINK = "Link",
  LIST = "List",
  LOADER = "Loader",
  MENU = "Menu",
  MENU_BUTTON = "MenuButton",
  MODAL = "Modal",
  MULTI_STEP_INDICATOR = "MultiStepIndicator",
  NUMBER_FIELD = "NumberField",
  RADIO_BUTTON = "RadioButton",
  SEARCH = "Search",
  SKELETON = "Skeleton",
  SLIDER = "Slider",
  SPLIT_BUTTON = "SplitButton",
  STEPS = "Steps",
  TAB = "Tab",
  TABLE = "Table",
  TEXT = "Text",
  TEXT_AREA = "TextArea",
  TEXT_FIELD = "TextField",
  TEXT_WITH_HIGHLIGHT = "TextWithHighlight",
  THEME_PROVIDER = "ThemeProvider",
  TIPSEEN = "Tipseen",
  TOAST = "Toast",
  TOGGLE = "Toggle",
  TOOLTIP = "Tooltip",
  VIRTUALIZED_GRID = "VirtualizedGrid",
  VIRTUALIZED_LIST = "VirtualizedList"
}
